import React from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from '@node-space/ui-components'
import { PaymentContextType } from 'types/payments'

interface ContactCaseListIconProps {
  paymentContextType: PaymentContextType
}

export const ContactCaseListIcon = ({ paymentContextType }: ContactCaseListIconProps) => {
  const { t } = useTranslation()

  switch (paymentContextType) {
    case PaymentContextType.CHANNEL_PAYMENT:
      return <Icon name="QrCode" size="small" aria-label={t('contacts.channelPayment')} />
    case PaymentContextType.PAYMENT_IN:
      return <Icon name="CoinArrowInCustom" size="small" aria-label={t('contacts.cryptoPayment')} />
    case PaymentContextType.DEPOSIT:
      return <Icon name="ArrowDownLeft" size="small" aria-label={t('contacts.directDeposit')} />
    default:
      return
  }
}
